import React, { useState } from "react";
import "./COC.css";
import moment from "moment";
import { apiCall } from "../api/apiUtil";
import { useNavigate } from "react-router-dom";
import {
    Row,
    Col,
    Button,
    Card,
    Table,
    Form,
    Container,
    Modal,
    Tabs,
    Tab,
} from "react-bootstrap";
import {
    FaTachometerAlt,
    FaCalendarAlt,
    FaUsers,
    FaUser,
    FaArrowRight,
    FaSpinner,
} from "react-icons/fa"; // Import Calendar Icon
import { FaCircleStop, FaCloudArrowDown, FaHand, FaBan } from "react-icons/fa6";

const VendorCoc = () => {
    // alert(sessionStorage.getItem("Id"));
    const [complianceId, setComplianceId] = sessionStorage.getItem("VendorCoCComplianceId");
    const [vendorCode, setVendorCode] = useState(sessionStorage.getItem("vendorCode"));
    const [vendorName, setVendorName] = useState(sessionStorage.getItem("vendorName"));
    const [isChecked, setIsChecked] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [fileUploadingFlag, setFileUploadingFlag] = useState(false);

    const [businessinterestStatus, setBusinessinterestStatus] = useState(false);

    const [businessList, setBusinessList] = useState([
        { empCode: "", name: "", relationship: "" },
    ]);
    const [formData, setFormData] = useState({
        id: Number(complianceId),
        selfInput: "",
        selfStatus: "",
        businessinterestStatus: businessinterestStatus,
        businessinterestList: JSON.stringify(businessList)
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Handle conflictStatus updates differently
        if (name === "BusinessinterestStatus") {
            setFormData((prev) => ({
                ...prev,
                businessinterestStatus: value === "1" ? true : false,
            }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleCheckboxChange = (section, value) => {
        setFormData((prev) => {
            const updated = prev[section].includes(value)
                ? prev[section].filter((item) => item !== value)
                : [...prev[section], value];
            return { ...prev, [section]: updated };
        });
    };

    const removeBusinessInterestRow = (indexToRemove) => {
        setBusinessList(businessList.filter((_, i) => i !== indexToRemove));
    };

    const handleConflictTypeChange = (type) => {
        setFormData((prev) => ({
            ...prev,
            [type]: prev[type] === 1 ? 0 : 1, // Toggle between 0 and 1
        }));
    };

    const handleConflictDescriptionChange = (type, value) => {
        setFormData((prev) => ({
            ...prev,
            [`${type}Description`]: value,
        }));
    };

    const handleBusinessInterestChange = (index, field, value) => {
        const updated = [...businessList];
        updated[index][field] = value;
        setBusinessList(updated);
    };

    const addBusinessInterestRow = () => {
        setBusinessList([
            ...businessList,
            { empCode: "", name: "", relationship: "" },
        ]);
    };

    // Handle File Upload
    //   const handleFileUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (file != null) {
    //       UploadSignature(globalId, year, month, file);
    //     }
    //   };
    //   const UploadSignature = async (globalId, year, month, file) => {
    //     setFileUploadingFlag(true);
    //     const formData = new FormData();
    //     formData.append("file", file);
    //     console.log("FILE Data:", JSON.stringify(formData));
    //     const response = await apiCall(
    //       `/CodeofconductForm/UploadSignature/${globalId}/${year}/${month}`,
    //       {
    //         method: "POST",
    //         body: formData,
    //       }
    //     );
    //     setFileUploadingFlag(false);
    //     if (response?.success) {
    //       setSignature(response?.fileDetail);
    //       //   setDisableSubmitButton(false);

    //       alert("Signature Uploaded.");
    //     } else {
    //       alert("Some issue occur. Please try uploading again.");
    //     }
    //   };
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if(file != null) {
            uploadSelfEvidence(complianceId, file);
        }
        //const updatedCategories = [...categories];
        //updatedCategories[index].selfEvidence = file;
        //setCategories(updatedCategories);
    };
    const uploadSelfEvidence = async(compId, file) => {
        setFileUploadingFlag(true);
        const formData = new FormData();
        formData.append('file', file);
        const response = await apiCall("/VendorCompliance/UploadVendorCompliance?vendorComplianceId=" + compId, {
            method: "POST",
            body: formData,
        });
        setFileUploadingFlag(false);
        if(response?.success) {            
            alert(response?.message);
        } else {
            alert("Some issue occur. Please try uploading again.");
        }
    }

    // const showAlert = () => {
    //     return confirm(
    //         "Please confirm the following before submission:\n\n" +
    //         "1. The CoC declaration form is submitted on non-judicial stamp paper.\n" +
    //         "2. No manipulation or alteration has been made in the CoC compliance content.\n" +
    //         "3. All disclosed relationships are accurate and I take full responsibility.\n" +
    //         "4. In case of any discrepancy or deviation, Naveen Jindal Group may take legal action as per contract terms.\n\n" +
    //         "Click OK to proceed or Cancel to review."
    //     );
    // }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isChecked === false) {
            alert("Acceptance of Code of Conduct compliance is required.");
            return;
        }
        // if (formData.BusinessinterestStatus === 1) {
        // 	alert("Please provide at least one business interest.");
        // 	return;
        // }
        //return showAlert();

        //e.preventDefault();
        // let conf = confirm("Are you sure you want to submit the form ");
        // if (!conf) {
        //     return;
        // }
        setShowConfirmationModal(true);
    };

    const saveCocForm = async () => {
        let codeOfConductForm = formData;
        if (
            businessList[0]?.empCode != "" &&
            businessList[0]?.name != "" &&
            businessList[0]?.relationship != ""
        ) {
            codeOfConductForm.businessinterestList = JSON.stringify(businessList);
        } else {
            codeOfConductForm.businessinterestList = "[]";
        }

        // codeOfConductForm.Signature = JSON.stringify(signature);
        setFormData(codeOfConductForm);
        //console.log("Form Data:", JSON.stringify(formData));
        try {
            const response = await apiCall("/VendorCompliance/UpdateVendorCompliance", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });
            
            setShowConfirmationModal(false);

            if (response?.success) {
                alert(response?.message);
                navigate("/vendor-dashboard");
            } else {
                alert("Error: " +response?.message);
            }
        } catch (error) {
            console.error("Error during form submission:", error);
        }
    };

    return (
        <div id="coc-form" className="d-flex flex-column min-vh-100">
            <form onSubmit={handleSubmit}>
                {/* className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-xl space-y-6"
                    className="w-full px-4 sm:px-6 lg:px-8 bg-white shadow-lg rounded-xl space-y-6" */}

                <h2 className="text-2xl font-bold text-center">
                    Vendor Code Of Conduct
                </h2>
                <p className="text-center font-medium">
                    UNDERTAKING AND DECLARATION
                </p>

                {/* Employee Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Vendor Name:
                        </label>
                        <input
                            type="text"
                            name="Name"
                            value={vendorName}
                            onChange={handleChange}
                            className="w-full border p-2 rounded mb-4"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Vendor Code:
                        </label>
                        <input
                            type="text"
                            name="GlobalCode"
                            value={vendorCode}
                            onChange={handleChange}
                            className="w-full border p-2 rounded mb-4"
                            required
                            readOnly
                        />
                    </div>
                </div>

                {/* Sections with bullet points */}
                <div>
                    <h3 className="text-xl font-semibold mt-6">
                        1. Code of Conduct Compliance
                    </h3>
                    <input
                        type="checkbox"
                        id="myCheckbox"
                        checked={isChecked}
                        onChange={() => setIsChecked(!isChecked)} style={{ marginTop: "15px" }}
                    />
                        I have read, understood, and commit to uphold the Code of Conduct.
                    <br />
                    <br />
                        <label className="font-semibold">
                        <span style={{ color: "red" }}>*</span>Upload the Compliance Declaration on Non-judicial Stamp Paper:
                        </label>
                        <input
                            type="file"
                            onChange={(event) => handleFileUpload(event)}
                            className="w-full border p-2 rounded"
                            required />
                </div>

                {/* Business Interests */}
                <div>
                    <h3 className="text-xl font-semibold mt-6">
                        2. Declaration of Business Interests
                    </h3>
                    <p className="mb-2">
                        In accordance with the principles of transparency and integrity, we hereby declare any business interest or significant ownership held by us or our close relatives in any company that engages in business with  Naveen jindal group  or its affiliates.
                    </p>
                    <label className="block mb-2">
                        <input
                            type="radio"
                            name="BusinessinterestStatus"
                            value="0"
                            checked={formData.businessinterestStatus === false}
                            onChange={handleChange}
                        />{" "}
                        I have no such business interests to declare.
                    </label>
                    <label className="block mb-4">
                        <input
                            type="radio"
                            name="BusinessinterestStatus"
                            value="1"
                            checked={formData.businessinterestStatus === true}
                            onChange={handleChange}
                        />{" "}
                        I declare the following interests:
                    </label>
                    {formData.businessinterestStatus === true && (
                        <div className="w-full overflow-auto">
                            <table className="w-full border-collapse">
                                <thead>
                                    <tr>
                                        <th className="border px-4 py-2">Employee Code</th>
                                        <th className="border px-4 py-2">Associate/Company Name</th>
                                        <th className="border px-4 py-2">Relationship (Self/Relative)</th>
                                        <th className="border px-4 py-2">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {businessList?.map((interest, index) => (
                                        <tr key={index}>
                                            <td className="border px-4 py-2">
                                                <input
                                                    type="text"
                                                    placeholder="Employee Code"
                                                    value={interest.empCode}
                                                    onChange={(e) =>
                                                        handleBusinessInterestChange(
                                                            index,
                                                            "empCode",
                                                            e.target.value
                                                        )
                                                    }
                                                    className="w-full border p-2 rounded" required
                                                />
                                            </td>
                                            <td className="border px-4 py-2">
                                                <input
                                                    type="text"
                                                    placeholder="Associate/Company Name"
                                                    value={interest.name}
                                                    onChange={(e) =>
                                                        handleBusinessInterestChange(
                                                            index,
                                                            "name",
                                                            e.target.value
                                                        )
                                                    }
                                                    className="w-full border p-2 rounded" required
                                                />
                                            </td>
                                            <td className="border px-4 py-2">
                                                <input
                                                    type="text"
                                                    placeholder="Relationship"
                                                    value={interest.relationship}
                                                    onChange={(e) =>
                                                        handleBusinessInterestChange(
                                                            index,
                                                            "relationship",
                                                            e.target.value
                                                        )
                                                    }
                                                    className="w-full border p-2 rounded" required
                                                />
                                            </td>
                                            <td className="border px-4 py-2 text-left space-x-2">
                                                {businessList?.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeBusinessInterestRow(index)}
                                                        className="text-red-600 font-semibold"
                                                    >
                                                        - Remove
                                                    </button>
                                                )}
                                                {index === businessList?.length - 1 && (
                                                    <>{businessList?.length > 1 && (<br />)}
                                                    <button
                                                        type="button"
                                                        onClick={addBusinessInterestRow}
                                                        className="text-blue-600 font-semibold"
                                                    >
                                                        + Add
                                                    </button>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">                    
                    <div>
                        {/* <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Date:
                        </label>
                        <input
                            type="date"
                            name="Date"
                            value={formData.Date}
                            onChange={handleChange}
                            className="w-full border p-2 rounded"
                            required
                            readOnly
                        /> */}
                    </div>
                    <div>
                        {/* <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Place:
                        </label>
                        <input
                            type="text"
                            name="Place"
                            value={formData.Place}
                            onChange={handleChange}
                            className="w-full border p-2 rounded"
                            required
                        /> */}
                    </div>
                    <div>
                        <button
                            type="submit"
                            //   disabled={disableSubmitButton}
                            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
                            style={{marginTop: "33px"}}
                        >
                            Declare
                        </button>
                    </div>
                </div>
                {/* <button
                    type="submit"
                    //   disabled={disableSubmitButton}
                    className="mt-6 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
                >
                    Declare
                </button>
                <button type="submit" class="btn btn-sm btn-success float-end">Submit</button> */}
            </form>
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Are you sure you want to submit the form ?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please confirm the following before submission: </p>
                    <ol>
                        <li>The CoC declaration form is submitted on non-judicial stamp Paper.</li>
                        <li>No manipulation or alteration has been made in the CoC compliance content.</li>
                        <li>All disclosed relationships are accurate and I take full responsibility.</li>
                        <li>In case of any discrepancy or deviation, Naveen Jindal Group may take legal action as per contract terms.</li>
                    </ol>
                    <p>Click Confirm to proceed or Cancel to review.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={saveCocForm}>
                        Confirm
                    </Button>
                    <Button variant="secondary" onClick={() => setShowConfirmationModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default VendorCoc;
